import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PriceComparatorSaved from '../../components/PriceComparator/PriceComparatorSaved';
import { PriceComparatorPackSelector } from '../../components/PriceComparator/PriceComparatorPackSelector';
import { PriceComparatorDetailProd } from '../../components/PriceComparator/PriceComparatorDetailProd';
import { PriceComparatorReport } from '../../components/PriceComparator/PriceComparatorReport';
import Header from '../../components/Header/Header';

const PriceComparatorPro: React.FC = () => {
	const { t } = useTranslation();

	const [currentStep, setCurrentStep] = useState<string>('saved');
	const [currentPack, setCurrentPack] = useState<
		| {
				userSubscriptionId: string;
				productCount?: number;
				countryCount?: number;
		  }
		| string
	>('');

	useEffect(() => {
		document.body.classList.remove('dark-overlay');
	}, []);

	return (
		<>
			<Header>{''}</Header>
			{currentStep === 'saved' && (
				<PriceComparatorSaved
					setCurrentStep={setCurrentStep}
					setCurrentPack={setCurrentPack}
				/>
			)}
			{currentStep === 'packs' && (
				<PriceComparatorPackSelector
					setCurrentStep={setCurrentStep}
					setCurrentPack={setCurrentPack}
				/>
			)}
			{currentStep === 'detail' && (
				<PriceComparatorDetailProd
					currentPack={currentPack}
					setCurrentStep={setCurrentStep}
				/>
			)}
			{currentStep === 'report' && <PriceComparatorReport setCurrentStep={setCurrentStep} />}
		</>
	);
};

export default PriceComparatorPro;
